ajaxifyCollection = function(isSearch){
	//code borrowed from https://github.com/Elkfox/Ajaxify
	var linkParent = '.pagination'; // Class of pagination container
	var parentContainer = 'body'; // All of the content selector used to detect scroll bottom distance
	var endlessScrollContainer = '.EndlessScroll'; // Selector for endless scroll pages
	var endlessOffset = 700; // Offset the distance from the bottom of the page
	var ajaxinateContainer = '.Ajaxinate'; // ID Selector for ajax pagination pages
	var ajaxinateLink = '.page a'; // Class Selector for ajax pagination links
	var fade = 'fast'; // fade speed
	var textChange = 'Loading'; // Text whilst loading content

	var linkElem;
	var contentContainer;
	var pageNumber;
	var pageType;
	var action;
	var moreURL;
	var moreURLCheck;
	var currentPage;

	var maxPages = $('.pagination').data('pages');
	var loadedLastPage = false;

	$.loadMore = function() {
		if(isSearch && moreURL !== undefined) {
			moreURLCheck = moreURL.substring(moreURL.lastIndexOf("?page=")+1,moreURL.lastIndexOf("&q="));
			moreURLCheck = moreURLCheck.split("page=");
			if (moreURLCheck[1]) {
				currentPage = moreURLCheck[1].split("&")[0];
				currentPage = Number(currentPage);
			} else {
				currentPage = null;
			}
		}
		else if (isSearch != true && moreURL !== undefined) {
			moreURLCheck = moreURL.split("page=");
			if (moreURLCheck[1]) {
				currentPage = moreURLCheck[1].split("&")[0];
				currentPage = Number(currentPage);
			} else {
				currentPage = null;
			}
		}
		else {
			currentPage = null;
		}
		if (currentPage != null && moreURL && moreURL.length && currentPage <= maxPages && loadedLastPage == false){
			$(linkElem).css('opacity', 0);
			$('.loader').show();
			$.ajax({
				type: 'GET',
				dataType: 'html',
				url: moreURL,
				success: function(data) {
					if(currentPage == maxPages) {
						loadedLastPage = true;
					}
					$(".pagination").css("position", "absolute");
					$(".loader").css("position", "absolute");
					var filteredData = $(data).find(contentContainer);
					if(filteredData.length === 0) {
						console.warn("[AJAXIFY] No filteredData found for selector");
					}
					var filteredDataProducts = filteredData[0] ? filteredData[0].innerHTML : null;
					var newProdHtml = $(filteredDataProducts);
					$(contentContainer).append(newProdHtml).hide().fadeIn(fade);
					var newProducts = newProdHtml;
					collectionGetVariations(newProducts);
					$(".swatch").click(function(){
						var swatchName = $(this).attr('class').split(' ')[1];
						var colorName = swatchName.replace('swatch-', '');
						var currentSwatch = '.' + $(this).attr('class').split(' ')[1];
						var findImage = '.image-' + colorName;
						$(this).closest(".product").find(".product-image-swatch").css("z-index", "-1");
						$(this).closest(".product").find(findImage).css("z-index", "2");
					});
					ModalQuickShop();
					$(linkElem).css('opacity', 0);
					$('.loader').hide();
					if (pageType == 'endlessScroll') {
						$.endlessScroll();
					}
				},
				timeout:15000,
				error: function(jqXHR, textStatus, errorThrown) {
					$('.loader').hide();
					$(linkElem).text("Load more");
					$(linkElem).css('opacity', 1);
				}
			});
		} else {
			console.log("[AJAXIFY] loadMore: Not making AJAX request. Condition failed.");
		}
	};

	 $.endlessScroll = function() {
	  action = 'scroll load resize';
	  $(window).on( action, function() {
		contentContainer = endlessScrollContainer;
		moreURL = $(linkElem).last().attr('href');
		pageType = 'endlessScroll';
		$(linkElem).text(textChange);
		var bottom;
		var docTop;

		if ($(contentContainer+':last-of-type '+linkElem).length || $(contentContainer).length == 1){
			if($(contentContainer).length == 1) {
				moreURL = $(linkElem).last().attr('href');
			}
			else {
				moreURL = $(linkElem).last().attr('href');
			}
		  bottom = $( parentContainer ).outerHeight();
		  docTop = ($(document).scrollTop() + $(window).height() + endlessOffset);
		  if( docTop > bottom ) {
			$(window).off(action);
			  $.loadMore();
		  }
		}
	  });
	};

	if ( $( endlessScrollContainer ).length ) {
	  linkElem = linkParent+' a';
	  $.endlessScroll();
	}
};
